var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"el-icon-printer",staticStyle:{"margin-left":"20px","font-size":"15px"},attrs:{"title":"暂存打印"},on:{"click":function($event){return _vm.printer(_vm.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }